import React from 'react'
import styled from 'styled-components'

class NoTripsFound extends React.Component {
	constructor(props) {
		super(props)
	}
	render() {
		return (
			<StyledNoTripsFound>
				<span className="blue f-xx-large no-trip">
					{this.props.message}
				</span>
			</StyledNoTripsFound>
		)
	}
}

const StyledNoTripsFound = styled.div`
	align-items: center;
	display: flex;
	height: 12rem;
	justify-content: center;
	text-align: center;

	.no-trip {
		line-height: 1em;
	}
`

export default NoTripsFound
